// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__PZmKn","text":"style_text__UhDg-","actions":"style_actions__drY24","actions_btn":"style_actions_btn__7nmay"};